import { lazy, Suspense } from "react";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Footer } from "@/components/site/Footer";
import { Reveal } from "@/components/motion/Reveal";
import { PageMeta } from "@/components/site/PageMeta";
import { useLang } from "@/i18n/LangContext";

const CertificateAreas = lazy(() =>
  import("@/components/site/CertificateAreas").then((m) => ({ default: m.CertificateAreas })),
);
const DrugTestingTeaser = lazy(() =>
  import("@/components/site/DrugTestingTeaser").then((m) => ({ default: m.DrugTestingTeaser })),
);
const Services = lazy(() =>
  import("@/components/site/Services").then((m) => ({ default: m.Services })),
);
const VisitSteps = lazy(() =>
  import("@/components/site/VisitSteps").then((m) => ({ default: m.VisitSteps })),
);
const BusinessSection = lazy(() =>
  import("@/components/site/BusinessSection").then((m) => ({ default: m.BusinessSection })),
);
const SamplingLocationsSection = lazy(() =>
  import("@/components/site/SamplingLocationsSection").then((m) => ({
    default: m.SamplingLocationsSection,
  })),
);
const Reviews = lazy(() =>
  import("@/components/site/Reviews").then((m) => ({ default: m.Reviews })),
);
const CTASection = lazy(() =>
  import("@/components/site/CTASection").then((m) => ({ default: m.CTASection })),
);

const Index = () => {
  const { t } = useLang();

  return (
    <div className="min-h-screen bg-background">
      <PageMeta title={t.hero.metaTitle} description={t.hero.metaDescription} />
      <Header />
      <main>
        <Hero />
        <Suspense fallback={null}>
          <Reveal>
            <CertificateAreas />
          </Reveal>
          <Reveal delay={40}>
            <DrugTestingTeaser />
          </Reveal>
          <Reveal delay={40}>
            <Services />
          </Reveal>
          <Reveal delay={40}>
            <VisitSteps />
          </Reveal>
          <Reveal delay={40}>
            <SamplingLocationsSection className="bg-muted/20" />
          </Reveal>
          <Reveal delay={40}>
            <BusinessSection />
          </Reveal>
          <Reveal delay={40}>
            <Reviews />
          </Reveal>
          <Reveal delay={40}>
            <CTASection />
          </Reveal>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
